import Decimal from 'break_infinity.js';

export { Decimal };

export function bn(value: number | string | Decimal): Decimal {
  return new Decimal(value);
}

export const ZERO = bn(0);
export const ONE = bn(1);
